module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/estadisticas-grey.3d8a174c.svg";